import { render, staticRenderFns } from "./DSTableIcon.vue?vue&type=template&id=d261e9ec&"
import script from "./DSTableIcon.vue?vue&type=script&lang=js&"
export * from "./DSTableIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports